import { FC, useMemo, useRef } from "react"
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar, Legend, Tooltip, LegendProps } from "recharts"
import { CustomXAxisTickOffsetX, customLegend, customTooltip, getYAxisWidth } from "../utility";

import {  ExceptionsData, TimeFrameOptions } from "../interfaces";

interface ExceptionsTableProps {
  data: ExceptionsData[];
  timeFrame: TimeFrameOptions;
  isExport: boolean;
  barHoverBackground?: string;
  exceptionsArray: string[];
}

const ExceptionsChart: FC<ExceptionsTableProps> = (props: ExceptionsTableProps) => {
  const itemsOrder = useRef([4, 3, 2, 1, 0]).current;

  const yAxisWidth = useMemo(() => {
    const yAxisValues = props.data?.map(
      (d) => d.exceptionsAppealed +
        d.exceptionsApproved +
        d.exceptionsDenied +
        d.exceptionsPending +
        d.exceptionsSubmitted
    );
    return getYAxisWidth(yAxisValues);
  }, [props.data]);

  return (
    <div style={{ height: "300px", width: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={500}
          data={props.data}
        >
          <CartesianGrid strokeDasharray="0 3" />
          <XAxis
            dataKey="month"
            height={32}
            tickLine={false}
            tickSize={8}
            interval={0}
            tick={<CustomXAxisTickOffsetX xOffset={20} />}
          />
          <YAxis
            axisLine={true}
            tickLine={false}
            width={yAxisWidth}
            tickSize={12}
            allowDecimals={false}
            tickFormatter={(tick: number) => tick.toLocaleString()}
          />
          {!props.isExport && (<Tooltip
            content={(props) => customTooltip(props, "month", itemsOrder)}
            itemStyle={{ background: "white", color: "black" }}
            cursor={{ fill: props.barHoverBackground }}
          />)}
          <Bar dataKey="exceptionsDenied" fill={props.exceptionsArray[0]} name="Denied Exceptions" stackId="exceptions" />
          <Bar dataKey="exceptionsAppealed" fill={props.exceptionsArray[1]} name="Appealed Exceptions" stackId="exceptions" />
          <Bar dataKey="exceptionsSubmitted" fill={props.exceptionsArray[2]} name="Submitted Exceptions" stackId="exceptions" />
          <Bar dataKey="exceptionsPending" fill={props.exceptionsArray[3]} name="Pending Exceptions" stackId="exceptions" />
          <Bar dataKey="exceptionsApproved" fill={props.exceptionsArray[4]} name="Approved Exceptions" stackId="exceptions" />
          <Legend
            /* LegendProps is an alias for InternalProps & AriaAttributes & DOMAttributesAdaptChildEvent
                Props is equal to InternalProps & PresentationAttributesAdaptChildEvent (which extends AriaAttributes and DOMAttributesAdaptChildEvent)
                Close enough 
            */
            content={(props) => customLegend(props as LegendProps, itemsOrder)}
            layout="vertical"
            wrapperStyle={{
              bottom: "100%",
              columns: 3,
              left: "50%",
              maxWidth: "600px",
              position: "relative",
              transform: "translateX(-50%)",
              width: "100%",
            }}
            verticalAlign="top"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
};

export default ExceptionsChart;